import { Link, useNavigate } from "react-router-dom";

// HOOKS
import useClickOutside from "../../../CustomHooks/ClickOutside";
import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";

// ICONS , PICS , STYLES
import styles from "./MyProfile.module.scss";
import { BsGearWideConnected } from "react-icons/bs";
import ToggleThemeButton from "../../UiComponents/ToggleThemeBtn/ToggleThemeButton";
import ToggleTooltipButton from "../../UiComponents/ToggleTooltipBtn/ToggleTooltipButton";
import LanguageSelector from "../../UiComponents/LanguageSelector/LanguageSelector";
import NavContext from "../../../context/NavContext";
import Axios from "../../../_services/caller.service";

const MyProfile = () => {
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const { nav, setNav, setUserAuth, setLoading, adminProfile } =
    useContext(NavContext);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const domNode = useClickOutside(() => {
    setIsProfileOpen(false);
  });

  const logout = () => {
    Axios.post("/logout")
      .catch(() => {}) // ignore errors — on déconnecte quoi qu’il arrive
      .finally(() => {
        setNav(!nav);
        setUserAuth(false);
        navigate("/");
      });
  };

  return (
    <div ref={domNode} className={styles.container}>
      {/* Gear Icon - open/close menu on click */}
      <BsGearWideConnected
  className={`${styles.settingIcon} has-tooltip ${isProfileOpen ? styles.active : ""}`}
  onClick={() => setIsProfileOpen((prev) => !prev)}
  aria-label={t("superadmin_ui.settings")}
/>


      {/* AVATAR/SETTINGS SUBMENU */}
      <div
        className={`${styles.menu} ${isProfileOpen ? styles.menu_active : ""}`}
      >
        <div className={styles.info}>
          <span className={styles.role}>{adminProfile && adminProfile.display_name}</span>
        </div>
        <div className={styles.settings}>
          <div className={styles.toggleRow}>
            <span>{t("profile.theme")}</span>
            <ToggleThemeButton />
          </div>
          {/* <div className={styles.toggleRow}>
            <span>{t("profile.tooltips")}</span>
            <ToggleTooltipButton />
          </div> */}
          <div className={styles.toggleRow}>
            <span>{t("profile.language")}</span>
            <LanguageSelector />
          </div>
          <Link to="/private/mon-compte">{t("profile.my_account")}</Link>
          <Link onClick={logout} to="">
            {t("profile.logout")}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default MyProfile;
